<template lang="pug">
div
  UiCardSection
    .ui-card-section-title {{ $t("admin_tools.tabs.logs") }}
  UiCardSection
    RestTable(
      namespace="logs"
      :headers="headers"
      ref="logsTable"
      :fetch-handler="getData"
      :initial-filters="initialFilters"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiStack
          UiStackItem(fill)
            UiFormGroup(
              :label="$t('admin_tools.digia_logs.event_type')"
              horizontal
            )
              UiMultiselect(
                :modelValue="filters.event_type"
                :options="eventsOptions"
                @update:modelValue="updateFilters({ event_type: $event })"
                :canDeselect="false"
                :canClear="false"
              )
          UiStackItem(fill)
            UiFormGroup(
              :label="$t('admin_tools.digia_logs.event')"
              horizontal
            )
              UiInput(
                :modelValue="filters.search"
                type="search"
                @update:modelValue="updateFilters({ search: $event })"
              )
          UiStackItem(fill)
            UiFormGroup(
              :label="$t('admin_tools.digia_logs.company')"
              horizontal
            )
              UiInput(
                :modelValue="filters.company_name"
                type="search"
                @update:modelValue="updateFilters({ company_name: $event })"
              )
          UiStackItem(fill)
            UiFormGroup(
              :label="$t('companies.automation.start_date')"
              label-for="start-date-input"
              horizontal
            )
              UiDatePicker(
                :modelValue="new Date(filters.start_date)"
                @update:modelValue="updateFilters({ start_date: startOfDay($event) })"
              )
          UiStackItem(fill)
            UiFormGroup(
              :label="$t('companies.automation.end_date')"
              label-for="end-date-input"
              label-cols="5"
            )
              UiDatePicker(
                :modelValue="new Date(filters.end_date)"
                @update:modelValue="updateFilters({ end_date: endOfDay($event) })"
              )
</template>
<script>
import ApiActionLogs from "@/api/digia_logs.js";
import { addMonths } from "@/common/date_utils";
import { endOfDay, startOfDay } from "@bi-book/bibook-ui-kit";

export default {
  data() {
    const startDate = startOfDay(addMonths(new Date(), -1));
    const endDate = endOfDay(new Date());

    return {
      events: [],
      initialFilters: {
        event_type: "all",
        search: "",
        company_name: "",
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
      },
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "created_at",
          label: "Event time",
          sortable: true,
          squeeze: false,
        },
        {
          key: "company",
          label: "Company",
          sortable: true,
        },
        {
          key: "subject",
          label: "Subject",
          sortable: true,
        },
        {
          key: "event",
          label: "Event",
          sortable: true,
        },
        {
          key: "body",
          label: "Body",
          sortable: true,
        },
        {
          key: "event_type",
          label: "Type",
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  computed: {
    eventsOptions() {
      return [
        {
          label: "All",
          value: "all",
        },
        ...this.events.map((i) => ({
          label: i[0],
          value: i[1],
        })),
      ];
    },
  },

  methods: {
    startOfDay: startOfDay,
    endOfDay: endOfDay,

    getData(params, config) {
      return ApiActionLogs.fetchLogs(
        {
          ...params,
          event_type: params.event_type === "all" ? null : params.event_type,
        },
        config,
      ).then((resp) => {
        return {
          items: resp.data.logs,
          meta: resp.data.meta,
        };
      });
    },
    fetchEvents() {
      ApiActionLogs.fetchEvents().then((resp) => {
        this.events = resp.data.events;
      });
    },
  },
  created() {
    this.fetchEvents();
  },
};
</script>
